import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    role = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.role.getDetail, { role }, options);
    if (error) return { error, status };
    return content || {};
};
